export default __webpack_public_path__ + "static/media/acces-denied.3b3a176e.svg";